/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function MaximumValue({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M5.5 2.4a.6.6 0 0 0 0 1.2h9a.6.6 0 1 0 0-1.2h-9ZM13.424 5.576a.599.599 0 0 1 .176.417V10a.6.6 0 1 1-1.2 0V7.449l-3.976 3.975a.6.6 0 0 1-.848 0L6 9.85l-3.576 3.575a.6.6 0 0 1-.848-.848l4-4a.6.6 0 0 1 .848 0L8 10.15 11.552 6.6H9a.6.6 0 1 1 0-1.2h4a.598.598 0 0 1 .424.176Z" /></svg>;
}
;